import { nanoid } from "nanoid";
import environment from "@/modules/environment";
import { messages } from "../deviceStats/messages";
import Xmpp from "../Xmpp";

const INTERVAL = 15 * 60 * 1000;

export default function createStatusMonitor(getAdditionalData?: Cb<undefined, Record<string, any>>) {
  const startDate = new Date();
  const xmpp = Xmpp.getInstance();

  const getCurrentState = async () => {
    try {
      //@ts-ignore
      const battery = await navigator.getBattery?.();
      const uptime = new Date().getTime() - startDate.getTime();

      const currentState: CurrentStateMessage = {
        presence: xmpp.presence,
        batteryLevel: Math.round((battery?.level || 1) * 100),
        uptime,
        additionalData: JSON.stringify(getAdditionalData?.() || {})
      };

      const encoded = messages.CurrentStateMessage.encode(currentState);
      const id = nanoid();
      const iq = $iq({
        type: "set",
        to: environment.xmppDomain,
        id
      }).c("data", { xmlns: "tappytaps:iq:setdevicestats" }, encoded);

      xmpp.sendIq(iq);
    } catch (error) {
      log.err("Failed getting currentState");
      log.err(error);
    }
  };

  getCurrentState();
  setInterval(getCurrentState, INTERVAL);
}
